import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  GeoJSON,
} from "react-leaflet";
import L from "leaflet";

import { Box, Typography } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";

function LocationMarker({ onSelect }) {
  const [position, setPosition] = useState(null);

  // useMapEvents({
  //   click(e) {
  //     setPosition(e.latlng);
  //     onSelect(e.latlng);
  //   },
  // });

  return position ? <Marker position={position} /> : null;
}

export default function LocationPicker({ setValue, watch }) {
  const mapRef = useRef();
  const geoJsonRef = useRef();

  const { t } = useTranslation();
  const coordinates = watch("coordinates");
  const cadastreInput = watch("cadastre");
  const [geoJson, setGeoJson] = useState(null);
  const [center, setCenter] = useState(
    coordinates?.lat && coordinates?.lng
      ? [coordinates.lat, coordinates.lng]
      : [56.95, 24.1]
  );

  // Fetch cadastre from backend
  const fetchParcel = async (cadastreId) => {
    if (!cadastreId) {
      setGeoJson(null);
      return;
    }
    try {
      const response = await fetch(`/api/auctions/cadastre/${cadastreId}`);
      if (!response.ok) throw new Error("Failed to fetch cadastre");
      const data = await response.json();
      setGeoJson(data.features && data.features.length > 0 ? data : null);

      const layer = L.geoJSON(data);
      const calcCenter = layer.getBounds().getCenter();
      // Update form coordinates
      setValue("coordinates", { lat: calcCenter.lat, lng: calcCenter.lng });

      //   console.log("Old center: ", center);
      setCenter([calcCenter.lat, calcCenter.lng]);

      if (mapRef.current) {
        mapRef.current.setView(
          [calcCenter.lat, calcCenter.lng],
          mapRef.current.getZoom(),
          {
            animate: true,
          }
        );
      }
    } catch (err) {
      console.error("Error fetching cadastre:", err);
      setGeoJson(null);
    }
  };

  useEffect(() => {
    if (geoJson && geoJson.features?.length && mapRef.current) {
      const layer = L.geoJSON(geoJson);
      const bounds = layer.getBounds();
      if (bounds.isValid()) {
        const calcCenter = bounds.getCenter();
        setValue("coordinates", { lat: calcCenter.lat, lng: calcCenter.lng });
        // console.log("New coords", calcCenter);

        // Pan the map immediately
        mapRef.current.fitBounds(bounds, { padding: [20, 20] });
      }
    }
  }, [geoJson]);

  // Debounce fetch to avoid spamming server
  const debouncedFetch = useRef(debounce(fetchParcel, 2000)).current;

  useEffect(() => {
    debouncedFetch(cadastreInput);
    return () => debouncedFetch.cancel();
  }, [cadastreInput, debouncedFetch]);

  return (
    <>
      <Typography sx={{ mt: 2 }} gutterBottom>
        {t("location_picker.click_to_select")}
      </Typography>

      <Box sx={{ height: 300, my: 2 }}>
        <MapContainer
          center={center}
          zoom={7}
          style={{ height: "100%", width: "100%", borderRadius: "8px" }}
          whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <LocationMarker
            onSelect={(latlng) =>
              setValue("coordinates", { lat: latlng.lat, lng: latlng.lng })
            }
          />
          {geoJson && (
            <GeoJSON data={geoJson} style={{ color: "green", weight: 3 }} />
          )}
        </MapContainer>
      </Box>
    </>
  );
}
